// React
import React from "react";
import { useTranslation } from "react-i18next";
// Chakra imports
import {
  Flex,
  Stat,
  StatLabel,
  StatNumber,
  useColorModeValue,
  Text,
  Button,
} from "@chakra-ui/react";
// Custom components
import Card from "components/card/Card.js";
// Icons
import { AddIcon } from "@chakra-ui/icons";
import { WalletIcon } from "components/icons/Icons";
import { IoSend } from "react-icons/io5";
import { MdRefresh } from "react-icons/md";

// Mini statistics card
function MiniStatistics({
  startContent,
  endContent,
  name,
  growth,
  value,
  controls,
  onControlClick,
}) {
  const { t } = useTranslation();
  const textColor = useColorModeValue("secondaryGray.900", "white");
  const textColorSecondary = "secondaryGray.600";

  // Button configs to avoid repetition
  const controlButtons = [
    { key: "create_wallet", label: t('Create Fiat Wallet'), icon: <WalletIcon /> },
    { key: "add_fiat", label: t('Add Fiat'), icon: <AddIcon /> },
    { key: "convert_balance", label: t('Convert Fiat'), icon: <MdRefresh /> },
    { key: "send_fiat", label: t('Send Fiat'), icon: <IoSend /> },
  ];

  return (
    <Card py="15px">
      <Flex
        my="auto"
        h="100%"
        align={{ base: "center", xl: "start" }}
        justify={{ base: "center", xl: "center" }}
      >
        {startContent}

        <Stat my="auto" ms={startContent ? "18px" : "0px"}>
          <StatLabel lineHeight="100%" color={textColorSecondary} fontSize="sm">
            {t(name)}
          </StatLabel>
          <StatNumber color={textColor} fontSize="2xl">
            {value}
          </StatNumber>
          {growth && (
            <Flex align="center">
              <Text color="green.500" fontSize="xs" fontWeight="700" me="5px">
                {growth}
              </Text>
              <Text color="secondaryGray.600" fontSize="xs" fontWeight="400">
                {t('since last month')}
              </Text>
            </Flex>
          )}
        </Stat>

        {endContent && (
          <Flex ms="auto" w="max-content">
            {endContent}
          </Flex>
        )}
      </Flex>

      {controls && (
        <Flex gap="10px" mt="10px" wrap="wrap">
          {controlButtons.map(({ key, label, icon }) => (
            <Button
              key={key}
              onClick={() => onControlClick && onControlClick(key)}
              colorScheme="brand"
              size="sm"
              leftIcon={icon}
              alignSelf="flex-start"
            >
              {label}
            </Button>
          ))}
        </Flex>
      )}
    </Card>
  );
}

export default React.memo(MiniStatistics);
